module.exports = __webpack_public_path__ + "img/bill.44b15e3b.png";